import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Variables d\'environnement Supabase manquantes');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Types TypeScript pour les tables
export interface Demande {
  id: string;
  nom_client: string;
  email: string;
  telephone: string;
  type_travaux: string;
  ville: string;
  code_postal: string;
  zone: string;
  description: string;
  budget_min: number;
  budget_max: number;
  prix: number;
  urgence: 'urgent' | 'normal';
  statut: 'nouveau' | 'en_cours' | 'vendu' | 'expire';
  image_chantier?: string;
  created_at: string;
  updated_at: string;
}

export interface WhatsAppSubscription {
  id: string;
  phone: string;
  department: string;
  is_active: boolean;
  created_at: string;
}

export interface AuthorizedUser {
  id: string;
  email: string;
  role: string;
  created_at: string;
}